import { ObjectTools } from '../../tools/object-tools';
import { SolText } from './sol-text';

export enum SolCheckboxValue {
  deselected = 'deselected',
  selected = 'selected',
  indeterminate = 'indeterminate',
}

export class SolCheckbox {
  private constructor(
    public readonly disabled: boolean,
    public readonly focused: boolean,
    public readonly value: SolCheckboxValue,
    public readonly text: string,
    public readonly info: SolText | undefined,
    public readonly custom: boolean,
    public readonly selected: boolean,
  ) {}

  public static of(): SolCheckbox {
    return new SolCheckbox(false, false, SolCheckboxValue.deselected, '', undefined, false, false).calculateSelected();
  }

  public withDisabled(disabled: boolean): SolCheckbox {
    return this.copy({ disabled });
  }

  public withFocused(focused: boolean): SolCheckbox {
    return this.copy({ focused });
  }

  public withValue(value: SolCheckboxValue): SolCheckbox {
    return this.copy({ value }).calculateSelected();
  }

  public withSelected(selected: boolean): SolCheckbox {
    return this.copy({ value: selected ? SolCheckboxValue.selected : SolCheckboxValue.deselected }).calculateSelected();
  }

  public withToggle(): SolCheckbox {
    const value = this.value === SolCheckboxValue.selected ? SolCheckboxValue.deselected : SolCheckboxValue.selected;
    return this.copy({ value }).calculateSelected();
  }

  public withText(text: string): SolCheckbox {
    return this.copy({ text });
  }

  public withInfo(info: SolText | undefined): SolCheckbox {
    return this.copy({ info });
  }

  public withCustom(custom: boolean): SolCheckbox {
    return this.copy({ custom });
  }

  private calculateSelected(): SolCheckbox {
    const selected = this.value === SolCheckboxValue.selected;
    return this.copy({ selected });
  }

  private copy(props: Partial<SolCheckbox>): SolCheckbox {
    return ObjectTools.copy<SolCheckbox>(this, props);
  }
}
